export default __webpack_public_path__ + "static/media/pendingCollectionIcon.33f3777a.svg";